import React from 'react';

const Label: React.FC = (props) => {
  return <label className='mb-0'>{props.children}</label>
};

export default Label;